'use client'

import { type TestIds, createContext } from '../../../utils/index.ts'

export type SectionHeaderSize = 'sm' | 'md' | 'lg'

export type UseSectionHeaderProps = TestIds & {
  size?: SectionHeaderSize
}

export function useSectionHeader(props: UseSectionHeaderProps) {
  const { dataTestId, dataTrackingId, size = 'md' } = props

  return {
    dataTestId,
    dataTrackingId,
    size,
  }
}

export const [SectionHeaderProvider, useSectionHeaderContext] = createContext<
  ReturnType<typeof useSectionHeader>
>({
  name: 'SectionHeaderContext',
})
